import { render, staticRenderFns } from "./BasePartner.vue?vue&type=template&id=530758ee&"
import script from "./BasePartner.vue?vue&type=script&lang=js&"
export * from "./BasePartner.vue?vue&type=script&lang=js&"
import style0 from "./BasePartner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports